import { APPLICATION_ENVIRONMENT } from "../../constants/env";
import { getEnvironmental } from "./getEnvironmental";
/**
 * @returns boolean
 */
const isProduction = () => {

  return getEnvironmental('applicationEnvironment') === APPLICATION_ENVIRONMENT.PRODUCTION;

};
/**
 * @returns boolean
 */
const isLocal = () => {

  return getEnvironmental('applicationEnvironment') === APPLICATION_ENVIRONMENT.LOCAL;

};

/**
 * Node runtime environment value used across server/client code.
 * Defaults to `development` when not explicitly provided.
 */
const getNodeEnvironment = () => getEnvironmental('NODE_ENV') || 'development';

/**
 * Canonical development-mode check for the codebase.
 */
const isDevelopment = () => getNodeEnvironment() === 'development';

export { isProduction };
export { isLocal };
export { getNodeEnvironment };
export { isDevelopment };
